import { twClassMerge } from '@healthhub/react-ui';
import { Typography } from 'antd';
import { memo } from 'react';


const { Text } = Typography;

interface SelectionComponentProps {
  buttonText: string;
  isDisabled?: boolean;
  onClick?: () => void;
  status?: React.ReactNode;
  title: string;
  value?: string;
}

const SelectionComponent = ({ buttonText, isDisabled, onClick, title, value, status }: SelectionComponentProps) => (
  <button
    className={twClassMerge(
      `polyclinic-selector flex w-full items-center justify-between gap-x-1 rounded-lg border-2 border-solid bg-white p-4 hover:border-slate-400 hover:opacity-70 lg:w-1/2`,
      value && 'py-2',
      isDisabled && 'opacity-50 bg-functional-stone hover:border-functional-stone hover:opacity-50 cursor-not-allowed'
    )}
    {...(!isDisabled && {
      onClick,
    })}
    data-testid="selection-component"
    type="button"
  >
    <div className="flex flex-col">
      <Text className={twClassMerge('text-base text-functional-iron text-left', value && 'text-xs')} id="title">
        {title}
      </Text>
      {!!value && <Text className="gbmask text-left text-base font-semibold">{value}</Text>}
    </div>
    <div className="flex items-center gap-3">
      {!!status && status}
      <Text className="button-text cursor-pointer whitespace-nowrap text-sm font-semibold text-theme-600">
        {buttonText}
      </Text>
    </div>
  </button>
);

export default memo(SelectionComponent);
